import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SyncLogout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.storageArea === localStorage && event.key === "logout") {
        // If logout key is detected, redirect to login
        navigate("/login");
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);
}
